<div class="container" *ngIf="registerCompanyInfo">
  
  <div class="company-tabs" role="tablist" aria-label="Company menu tabs">
    <button
      type="button"
      class="company-tab"
      [class.active]="activeTab === 'participants'"
      (click)="goTab('participants')">
      Participants
    </button>
    <button
      type="button"
      class="company-tab"
      [class.active]="activeTab === 'availableTime'"
      (click)="goTab('availableTime')">
      Available Time
    </button>
    <button
      type="button"
      class="company-tab"
      [class.active]="activeTab === 'presentation'"
      (click)="goTab('presentation')">
      Presentation
    </button>
    <button
      type="button"
      class="company-tab"
      [class.active]="activeTab === 'meetingSchedule'"
      (click)="goTab('meetingSchedule')">
      Meeting Schedule
    </button>
  </div>

  <div class="info-note-box shadow-sm mb-3" *ngIf="registerCompanyInfo.isCloseRegister">
    <i class="fas fa-info-circle info-note-icon"></i>
    <div>Remark: Registration is now closed. The participant list and available time slots can no longer be amended.</div>
  </div>

  <ng-container [ngSwitch]="activeTab">
    <app-company-participant-section
      *ngSwitchCase="'participants'"
      [participants]="form.get('participants')"
      [eventInfoWithConsent]="eventInfo"
      [dietaries]="dietaries"
      [noneDietaryId]="noneDietaryId"
      [registerCompanyId]="registerCompanyId"
      [isCloseRegister]="isCloseRegister"
      (submitParticipants)="onSaveParticipants($event)">
    </app-company-participant-section>

    <app-company-time-section
      *ngSwitchCase="'availableTime'"
      [slots]="form.get('slots')"
      [eventType]="eventInfo?.eventType"
      [isCloseRegister]="isCloseRegister"
      (submitSlots)="onSaveSlots($event)">
    </app-company-time-section>

    <app-company-presentation-section
      *ngSwitchCase="'presentation'"
      [registerCompanyInfo]="registerCompanyInfo"
      [selectedFile]="form.get('presentationFile').value"
      (selectedFileChange)="onPresentationFileChange($event)"
      (submitPresentation)="onSavePresentation($event)">
    </app-company-presentation-section>

    <app-company-meeting-schedule-section
      *ngSwitchCase="'meetingSchedule'"
      [isSentScheduleEmail]="registerCompanyInfo.isSentScheduleEmail"
      [contactEmail]="eventInfo?.emailFrom">
    </app-company-meeting-schedule-section>

  </ng-container>

</div>